<template>
  <div>
    <v-row :class="containerProps">
      <h2>{{ $t("noDataAvailable") }}</h2>
    </v-row>

    <v-row :class="containerProps">
      <v-icon color="primary" class="errImg">mdi-robot-dead</v-icon>
    </v-row>

    <v-row :class="containerProps + ' pt-10'">
      <p>{{ $t("noDataAvailableForSelectedParameters") }}</p>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "NoData",
  data: () => ({
    containerProps: "wrapper my-0 py-0"
  })
};
</script>

<style scoped>
.errImg {
  font-size: 100px;
}

.wrapper {
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
